<div [class.mobile]="isMobile()">
  <div class="content">
    <i nz-icon [nzType]="'icons:match-equipment'" class="svg-icon big-icon"></i>
    <h1>{{ i18n.langString("match_equipment") }}</h1>

    <div class="innercontent">
      <div class="input-area-wrapper">
        <div class="input-area input-distanced">
          <label class="select-label">
            {{ i18n.langString("plant_name") }}
            <span class="purple-alert-text">*</span>
          </label>
          <br /><br />
          <app-select
            [options]="plantList()"
            [placeholder]="i18n.langString('test_plant')"
            (selectedChange)="plantOptionsSelected($event)"
          >
          </app-select>
        </div>

        <div class="input-area input-distanced">
          <label class="select-label">
            {{ i18n.langString("add_equipment_name") }}
            <span class="purple-alert-text">*</span>
          </label>
          <br /><br />
          <app-select
            [selected]="selectedNPEquipment()"
            [disabled]="plantListselected()"
            [options]="equipmentList()"
            [placeholder]="i18n.langString('test_pump')"
            (selectedChange)="onOptionsSelected($event)"
          >
          </app-select>
        </div>

        <div style="display: flex">
          <div><i nz-icon nzType="icons:info" class="svg-icon-info"></i></div>
          <span>
            <b>
              {{ i18n.langString("match_mandatory_text1") }}
              “<span class="purple-alert-text">*</span>”
              {{ i18n.langString("match_mandatory_text2") }}
            </b>
          </span>
        </div>

        @if (matchConnect() && selectedNPEquipment() !== "Test Pump") {
          <div
            class="connect"
            style="color: #00aa75; display: flex; margin-top: 7px"
          >
            <div>
              <i
                nz-icon
                nzType="icons:Toast"
                class="svg-icon multicolorIcon"
              ></i>
            </div>
            {{ i18n.langString("match_connect") }}
          </div>
        }
      </div>
    </div>
  </div>
</div>
